import React from "react";
import PropTypes from "prop-types";
import { ManualForm } from "../../components";

export const ManualEnquiry = ({
  handleSubmit,
  onSubmit,
  errors,
  register,
  reg,
  setReg,
  handleSellVan,
  setRegRequired,
  regRequired,
  regFormatIncorrect,
  setRegFormatIncorrect
}) => {
  return (
    <>
      <p className="ch-fs--4">We can&apos;t seem to find your vehicle</p>
      <p className="ch-color--grey-6 ch-fs--3">
        Check and re-enter your registration or enter your car&apos;s details
        manually.
      </p>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div
          className={`ch-form__group ch-mb--0
            ${
              errors.registration || regRequired || regFormatIncorrect
                ? "ch-form__group--error"
                : ""
            }
            `}
        >
          <label
            htmlFor="registration"
            className="ch-form__control-label ch-width--12"
          >
            Registration
            <span className="ch-form__control-validation">
              {!regRequired &&
                !regFormatIncorrect &&
                errors.registration?.message}
              {regRequired && "Please enter registration"}
              {regFormatIncorrect &&
                "Please make sure your registration is in the correct format"}
            </span>
            <input
              type="text"
              name="registration"
              id="registration"
              className="ch-form__control ch-bg--ac-yellow reg-input ch-mb--3"
              placeholder={reg || "ENTER REG"}
              {...register("registration")}
              onChange={(e) => {
                setRegRequired(false);
                setRegFormatIncorrect(false);
                setReg(e.target.value);
              }}
            />
          </label>
        </div>
        <div className="ch-display--flex ch-justify-content--between">
          <button
            className="ch-btn ch-btn--success ch-width--4 ch-text--center"
            type="submit"
          >
            Retry
          </button>
          <button
            className="ch-btn ch-btn--link"
            type="button"
            onClick={handleSellVan}
          >
            Selling a van?
          </button>
        </div>
      </form>

      <ManualForm
        setRegRequired={setRegRequired}
        setRegFormatIncorrect={setRegFormatIncorrect}
      />
    </>
  );
};

ManualEnquiry.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    registration: PropTypes.shape({
      message: PropTypes.string
    })
  }),
  register: PropTypes.func.isRequired,
  reg: PropTypes.string,
  setReg: PropTypes.func
};
